import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "file-arae" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Search ")
const _hoisted_3 = {
  key: 0,
  style: {"margin-left":"150px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "DaoId"),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "Token"),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"400px"} }, "Contract"),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "Amount")
], -1)
const _hoisted_5 = { style: {"width":"100px"} }
const _hoisted_6 = { style: {"width":"100px"} }
const _hoisted_7 = { style: {"width":"400px"} }
const _hoisted_8 = { style: {"width":"100px"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Prev ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Next ")

import { ref } from 'vue'

import { connected, connectState } from "../libs/connect"
import * as tools from "../libs/tools"
import * as covalent from "../libs/covalent"

import { greenVoteContractAddress, chainList } from "../constant"

import { GreenDao } from "../libs/greendao"
import { GreenVote } from "../libs/greenvote"

// const userAddr = connectState.userAddr;

const __default__ = {
  name: 'TreassuresPage',
  props: {
  }
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const searchAddress = ref('');

const activeName = connectState.activeName;
const loadStatus = ref(false);

const greendao = new GreenDao();
const greenvote = new GreenVote();

const treassureList = ref(new Array());
const hasMore = ref(false);
const pageSize = ref(10);
const pageCount = ref(0);

const svg = `
        <path class="path" d="
          M 30 15
          L 28 17
          M 25.61 25.61
          A 15 15, 0, 0, 1, 15 30
          A 15 15, 0, 1, 1, 27.99 7.5
          L 15 15
        " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
      `;

//address explore url
const addressExplorerUrl = (address:string) => {
  for(const i in chainList){
    if(connectState.chainId === chainList[i].chainId){
      const blockExplorerUrls = chainList[i].blockExplorerUrls;
      return `${blockExplorerUrls}/address/${address}`
    }
  }
  return address;
}    

const getTreassureCount = async (searchDaoId:number) => {
  const newList = new Array();

  const tokens = new Array();
  let nativeCurrency = 'ETH';
  for(let i = 0; i < chainList.length; i++){
    if(chainList[i].chainId === connectState.chainId){
      nativeCurrency = chainList[i].nativeCurrency;
      break;
    }
  }

  tokens.push({
    name: nativeCurrency,
    contract: "0x0000000000000000000000000000000000000000",
    decimals: 18,
  });

  const tokenInfos = await covalent.getTokenBalancesForAddress(connectState.chainId, greenVoteContractAddress[connectState.chainId]);
  for (let i = tokenInfos.length-1; i>=0; i--){
    const item = tokenInfos[i];

    if(item.type === 'nft'){
      continue;
    }

    if(item.balance === null || parseInt(item.balance) === 0){
      continue;
    }

    tokens.push({
      name: item.contract_ticker_symbol,
      contract: item.contract_address,
      decimals: item.contract_decimals,
    });
  }

  const total = await greendao.getDaoTotalCount();
  let count = 0;

  for(let i = 0; i <= total/10; i++){
    let indexs;
    if(searchDaoId > 0){
      indexs = [searchDaoId];
    }else{
      indexs = await greendao.getDaoIndexsByPageCount(10, i, false);
    }

    for(let j = 0; j < indexs.length; j++){
      const daoId = indexs[j];
      for(let k = 0; k< tokens.length; k++){

        try{
          const balance = await greenvote.getDaoTreassure(daoId, tokens[k].contract);

          if(balance <= 0){
            continue;
          }else{
            count++;
          }

          if(pageSize.value*pageCount.value > count){
            continue;
          }

          if(count > pageSize.value*(pageCount.value+1)){
            break;
          }

          newList.push({
            daoId: daoId,
            token: tokens[k].contract,
            name: tokens[k].name,
            amount: balance,
          })
        }catch(e){
          continue;
        }

      }
    }

    if(searchDaoId > 0){
      break;
    }
  }

  if(newList.length < pageSize.value){
    hasMore.value = false;
  }else{
    hasMore.value = true;
  }

  treassureList.value = newList;
}
//on click for prev page
const onHandlePrev = async () => {
  if(pageCount.value > 0){
    pageCount.value--;
  }
  handleClick();
}

//on click for next page
const onHandleNext = async () => {
  if(hasMore.value){
    pageCount.value++;
  }
  handleClick();
}

//handle page refresh
const handleClick = async () => {
  //wait for the active name change
  await tools.sleep(100);

  connectState.activeName.value = activeName.value;
  tools.setUrlParamter('activeName', activeName.value);

  try{
    loadStatus.value = true;
    if (!(await connected())){
      treassureList.value = new Array();
      return;
    }

    if(pageCount.value < 0){
      pageCount.value = 0;
    }

    let searchDaoId = parseInt(searchAddress.value);
    if(isNaN(searchDaoId)){
      searchDaoId = 0;
    }

    await getTreassureCount(searchDaoId);

  }catch(e){
    treassureList.value = new Array();
  }finally{
    loadStatus.value = false;
  }
}

//clean search content and bind search callback function
connectState.search = '';
connectState.searchCallback = handleClick;
//try get activeName from the url paramter
try{
  activeName.value = tools.getUrlParamter('activeName');
  if(activeName.value != 'balance'){

    activeName.value = 'balance';
  }
}catch(e){
  activeName.value = 'balance';
}

//update page size
handleClick();  

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_document_copy = _resolveComponent("document-copy")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { style: {"background-color":"#ffffff"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tabs, {
              modelValue: _unref(activeName),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeName) ? (activeName).value = $event : null)),
              class: "file-tabs",
              onTabClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "Balance",
                  name: "balance"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              modelValue: searchAddress.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchAddress).value = $event)),
              placeholder: "0",
              size: "small",
              style: {"width":"350px"}
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: handleClick
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_main, {
          style: {"height":"450px","margin-top":"20px"},
          "element-loading-text": "Loading...",
          "element-loading-spinner": svg,
          "element-loading-svg-view-box": "-10, -10, 50, 50",
          "element-loading-background": "#ffffff"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                (_unref(activeName) === 'balance')
                  ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
                      _hoisted_4,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(treassureList.value, (info) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: info.daoId+info.token
                          }, [
                            _createElementVNode("td", _hoisted_5, _toDisplayString(info.daoId), 1),
                            _createElementVNode("td", _hoisted_6, _toDisplayString(info.name), 1),
                            _createElementVNode("td", _hoisted_7, [
                              _createVNode(_component_el_link, {
                                type: "success",
                                target: "_blank",
                                href: addressExplorerUrl(info.token)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(info.token), 1)
                                ]),
                                _: 2
                              }, 1032, ["href"]),
                              _createVNode(_component_el_icon, {
                                onClick: ($event: any) => (_ctx.onClickToCopy(info.token))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_document_copy)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _createElementVNode("td", _hoisted_8, _toDisplayString(info.amount), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_loading, loadStatus.value]
        ]),
        _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-top":"10px"},
                onClick: onHandlePrev
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-top":"10px"},
                onClick: onHandleNext,
                disabled: !hasMore.value
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})